import { createContext, useContext } from 'react';

import type { IWebHookScreenContext } from 'v2/interfaces/webhook';
import type { IWebHookHistoricContext } from 'v2/interfaces/webhook/historic';
import type { IWebHookContext } from 'v2/interfaces/webhook/webhook';

export const WebHookScreenContext = createContext<IWebHookScreenContext>({} as IWebHookScreenContext);
export const WebHookContext = createContext<IWebHookContext>({} as IWebHookContext);
export const WebHookHistoricContext = createContext<IWebHookHistoricContext>({} as IWebHookHistoricContext);

export function useWebHookScreen() {
  const context = useContext(WebHookScreenContext);
  return context;
}

export function useWebHook() {
  const context = useContext(WebHookContext);
  return context;
}

export function useWebHookHistoric() {
  const context = useContext(WebHookHistoricContext);
  return context;
}

export default WebHookContext;
